// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoInput_wrapper__3lhcl","input":"VideoInput_input__OO4f5","placeholder":"VideoInput_placeholder__3lYjI","icon":"VideoInput_icon__1rmmi"};